/** 상점 월별 통계 엔티티 */
export default class StatsStoreMonthly {
    /** 아이디 */
    id = 0;
    /** 허브 이름 */
    hubName = '';
    /** 상점 이름 */
    storeName = '';
    /** 날짜 */
    date = '';
    /** 전체 건수 */
    allCount = 0;
    /** 완료 */
    completedCount = 0;
    /** 상품 가격 */
    goodsPrice = 0;
    /** 건당 단가 */
    unitPrice = 0;
    /** 카드 건수 */
    creditCardCount = 0;
    /** 카드 금액 */
    creditCardPrice = 0;
    /** 카드 비율 */
    creditCardPercent = 0;
    constructor(_data = {}) {
        Object.assign(this, _data);
    }
}
